import React from 'react';

// project-imports
import { slugify } from '../../utils';
import SEO from '../../common/SEO';
import Layout from '../../common/Layout';
import PostOne from '../../components/post/PostOne';
import BreadcrumbOne from '../../common/breadcrumb/BreadcrumbOne';

// third-party
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

const CategoryArchive = () => {

    // property initialization
    const { slug } = useParams();

    // Rading store data
    const blogData = useSelector(item => item.blog.blogs);

    // Constant variable
    const data = (blogData || [])?.map(blog => {
        return {
            ...blog,
            categories: blog?.categories && blog?.categories.length && blog?.categories?.filter(catItem => slugify(catItem) === slug)
        }
    }).filter(blog => blog?.categories.length > 0);

    const catTitle = data && data?.length && data[0].categories.length && (data[0].categories[0] || "");

    return (
        <>
            <SEO title={`Longswitch Academy Courses On ${catTitle} Category`} url={process.env.PUBLIC_URL + `/course-category/${slugify(catTitle)}`} />
            <Layout searchDisable={true}>
                <BreadcrumbOne
                    title={catTitle}
                    rootUrl="/"
                    parentUrl="Home"
                    currentUrl={`Posts On ${catTitle} Category`}
                />
                <div className="edu-elements-area edu-section-gap bg-color-white">
                    <div className="container mb--80">
                        <div className="row g-5">
                            <div className="col-lg-12">
                                <div className="row g-5">
                                    {
                                        (data || [])?.map((item) => (
                                            <div className="col-lg-4 col-md-6 col-12" key={item.id}>
                                                <PostOne data={item} />
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    )
}

export default CategoryArchive;